import { t } from 'i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import Heading from '../../../generic-components/Heading';
import { useStore } from '../../../store';
import { CloseButton } from '../../../DesignSystem/LiliCloseButton/CloseButton';
import directDepositFormSent from '../../../assets/icons/svg/stamp-icons/ic-stamp-success.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/svg/shared/ic-shared-download.svg';

interface IProps {
  handleSendEmail: () => void;
  isRefetching: boolean;
  isLoading: boolean;
  isEmailSent: boolean;
  setIsEmailSent: (value: boolean) => void;
  title?: string;
}

export const EmailSection = ({
  handleSendEmail,
  isEmailSent,
  isLoading,
  isRefetching,
  setIsEmailSent,
  title,
}: IProps) => {
  const data = useStore((state) => state.summary);

  const POPUP_TITLE = t('DIRECT_DEPOSIT_PAGE_POPUP_TITLE');
  const POPUP_TEXT_1 = t('DIRECT_DEPOSIT_PAGE_POPUP_TEXT_WIRE');
  // const padding = !isEmailSent ? 'ml-[43px] mr-[54px] w-full ' : 'pl-[0] pr-[0] ';
  return (
    <div className='w-full pt-[10px]'>
      {!isEmailSent ? (
        <LiliButton
          title={title ?? t('WIRE_TRANSFER_WIRE_GENERATE_FORM')}
          id='directDepositSubmitForm'
          isLoading={isLoading || isRefetching}
          onClick={() => handleSendEmail()}
          className='w-full'
          type={LiliButtonType.SECONDARY}
          icon={<DownloadIcon />}
        />
      ) : (
        <p className='text-bw07 font-metric text-base mt-4'>
          <div className='w-[90%] py-4 mx-auto mt-[12px] mb-[16px] pl-1 bg-bw01 h-fit flex gap-[1.125rem] rounded-lg shadow-popup-md items-center select-none'>
            <img
              id='directDepositFormSent'
              className='w-[40px] h-[40px]'
              src={directDepositFormSent}
              alt='directDepositFormSent'
            />
            <div className='flex w-full flex-col relative'>
              <CloseButton
                onClick={() => setIsEmailSent(false)}
                id='closePopup'
                className='absolute -top-1 left-48 cursor-pointer'
              />
              <Heading id='popupTitle' className='font-metricBold text-lg text-bw08' title={POPUP_TITLE} />
              <span id='popupText' className='text-sm font-metric text-bw07'>
                {POPUP_TEXT_1}
              </span>
              <span
                id='popupUserEmail'
                className='w-[200px] text-bw08 text-sm font-metric truncate hover:bg-bw03 hover:overflow-visible hover:rounded hover:w-fit'
              >
                {`${data.customer.email}`}
              </span>
            </div>
          </div>
        </p>
      )}
    </div>
  );
};
